// 全局状态管理
let globalHost: string = '';
let globalI18nLocale: string = '';

export const setGlobalHost = (host: string) => {
  globalHost = host;
};

export const getGlobalHost = () => {
  return globalHost;
};

export const setGlobalI18nLocale = (locale: string) => {
  globalI18nLocale = locale;
};

export const getGlobalI18nLocale = () => {
  return globalI18nLocale;
}; 